import { Marker } from '@citiguide/shared';
import { useLanguageStore } from '../../store/languageStore';
import PoiDetail from './PoiDetail';
import './MarkerModal.css';

interface MarkerModalProps {
  marker: Marker;
  isOpen: boolean;
  onClose: () => void;
  onRouteRequest?: (type: 'walking' | 'driving') => void;
}

export default function MarkerModal({ marker, isOpen, onClose, onRouteRequest }: MarkerModalProps) {
  const { currentLanguage } = useLanguageStore();

  if (!isOpen) return null;

  return (
    <div className="marker-modal-scrim" onClick={onClose}>
      <div className="marker-modal-panel" onClick={(e) => e.stopPropagation()}>
        <PoiDetail
          marker={marker}
          lang={currentLanguage}
          variant="panel"
          onClose={onClose}
          onRouteRequest={onRouteRequest}
        />
      </div>
    </div>
  );
}
